import HttpRequest from './http_request'

class FacultyProvider extends HttpRequest {
  constructor() {
    // api api
    super(process.env.VUE_APP_ENDPOINT + 'api/')
  }

  async getFaculties() {
    const { data } = await this.get('faculty/', {
      function: 'get-faculty',
    })
    return data
  }
  async getFacultyById(id) {
    const { data } = await this.get('faculty/', {
      function: 'get-faculty',
      select: ["FACULTY_ID", "FACULTY_NAME_TH", "FACULTY_NAME_EN"],
      where: [{FACULTY_ID: id}]
    })
    return data
  }
  async getCurriculums(level_id) {
    const { data } = await this.get('curriculum/', {
      function: 'get-curriculum',
      LEVEL_ID: level_id,
    })
    return data
  }
  async setCurriculumTcasId(curriculum_id, tacs_id) {
    const { data } = await this.post('curriculum/', {
      function: 'set-curriculum',
      set: {
        CURRICULUM_ID: curriculum_id,
        TCAS_PROGRAM_ID: tacs_id,
      }
    })
    return data
  }
  async setCurriculumInter(curriculum_id, inter) {
    const { data } = await this.post('curriculum/', {
      function: 'set-curriculum',
      set: {
        CURRICULUM_ID: curriculum_id,
        INTER: inter,
      }
    })
    return data
  }
}

export default FacultyProvider